<template>
  <b-row class="px-lg-2 px-4">
    <b-col cols="12" lg="6" class="mb-4">
      <PageTitle title="Serviços" />
    </b-col>
    <b-col cols="12" lg="6" class="mb-4">
      <b-button 
        class="float-right"
        variant="success"
        @click="$refs.modalService.toggleOpen({ data: [] })"
      >
        <i class="fas fa-plus mr-2"></i>
        Novo Serviço
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>

        <template #cell(deadline)="data">
          {{ data.item.deadline }}
          <span v-if="data.item.deadline >1"> horas</span>
          <span v-else>hora</span>
        </template>

        <template #cell(service_guarantee)="data">
          {{ data.item.service_guarantee }} 
          <span v-if="data.item.service_guarantee >1"> meses</span>
          <span v-else>mês</span>
        </template>

        <template #cell(price)="data">
          R$ {{ formatMoneyUn(data.item.price) }} 
        </template>

        <template #cell(quantity)="data">
          {{ data.item.data_product_service.length }}
        </template>

        <template #cell(action)="data">
          <b-button
            class="ml-1"
            size="sm"
            variant="primary"
            :disabled="!whatClerkPermission()"
            @click="$refs.modalService.toggleOpen({ data: data.item, isNew: false })"
            v-b-tooltip.hover
            title="Editar serviço"
          >
            <i class="fas fa-edit"></i>
          </b-button>

          <b-button
            @click="
              $refs.insertServiceProductModal.toggleOpen({
                item: data.item,
                title: `Vincular produto(s) ao serviço de ${data.item.name}`
              })
            "
            class="ml-1"
            size="sm"
            variant="success"
            :disabled="!whatClerkPermission()"
            v-b-tooltip.hover
            title="Incluir produtos"
          >
            <i class="fas fa-plus"></i>
          </b-button>

          <b-button
            class="ml-1"
            size="sm"
            variant="danger"
            :disabled="!whatClerkPermission()"
            @click="$refs.deleteServiceModal.toggleOpen({ data: data.item })"
            v-b-tooltip.hover
            title="Apagar serviço"
          >
            <i class="fas fa-trash"></i>
          </b-button>

          <b-button
            class="ml-1"
            size="sm"
            variant="warning"
            :disabled="!whatClerkPermission()"
            @click="$refs.detailServiceModal.toggleOpen({ data: data.item })"
            v-b-tooltip.hover
            title="Detalhes do serviço"
          >
            <i class="fas fa-eye"></i>
          </b-button>
        </template>
      </b-table>

    </b-col>

    <modalService 
      ref="modalService"
      :title="isNew ? 'Cadastrar Novo' : 'Atualizar'"
      :fieldsForm="isNew ? {} : table.records"
      @newService="createService($event)"
      @updateService="editService($event)"
    />
    <DetailServiceModal 
      ref="detailServiceModal"
    />
    <InsertServiceProductModal 
      ref="insertServiceProductModal"
    />
    <DeleteServiceModal 
      ref="deleteServiceModal"
      @deleteService="deleteService($event)"
    />
  </b-row>
</template>

<script>
import PageTitle from '../../../components/PageTitle.vue';
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
import { mapActions } from 'vuex';
import ModalService from './ModalService.vue';
import DetailServiceModal from './DetailServiceModal.vue';
import InsertServiceProductModal from './InsertServiceProductModal.vue';
import DeleteServiceModal from './DeleteServiceModal.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';

export default {
    mixins: [makeToast],
    components: { 
      PageTitle, 
      ModalService,
      DetailServiceModal,
      InsertServiceProductModal,
      DeleteServiceModal
    },
    data() {
      return {
        isNew: true,
        loading: false,
        table: {
          headers: [
            {
              key: 'id',
              thClass: 'd-none',
              tdClass: 'd-none',
            },
            {
              key: 'name',
              label: 'Nome',
              sortable: false,
            },
            {
              key: 'price',
              label: 'Valor ',
              sortable: false,
            },
            {
              key: 'service_guarantee',
              label: 'Garantia',
              sortable: false,
            },
            {
              key: 'deadline',
              label: 'Prazo de instalação',
              sortable: false,
            },
            {
              key: 'quantity',
              label: 'Qtd. Produto',
              sortable: false,
            },
            {
              key: 'action',
              label: 'Ações',
              sortable: false,
            },
          ],
          records: [],
        }
      }
    },
    computed: {
      ...mapState(['dadosUsuario']),
    },
    mounted() {
      this.getServices();
    },
    methods: {
      ...mapActions('shopkeeper', [
        'getServiceShopkeeper',
        'createNewServiceShopkeeper',
        'deleteServiceShopkeeper',
        'updateServiceShopkeeper',
      ]),
      getServices() {
        this.$store.dispatch('startLoader');
        this.getServiceShopkeeper(this.userTypeId())
          .then((resp) => {
            this.table.records = resp.data.data;
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao pegar os serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      },
      createService(event){
        this.isNew = true;
      
        const data = {
          construp_user_id : this.userTypeId(),
          name : event.name,
          type : event.type,
          price : Number(event.price),
          deadline : Number(event.deadline),
          uf_state : event.uf_state ? event.uf_state : "" ,
          services_included : event.services_included ? event.services_included : "",
          services_not_included : event.services_not_included ? event.services_not_included : "",
          prepare_installation : event.prepare_installation ? event.prepare_installation : "",
          service_guarantee : Number(event.service_guarantee)
        }

        this.$store.dispatch('startLoader');
        this.createNewServiceShopkeeper(data)
          .then((resp) => {
            this.getServices();
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao cadastrar o serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      },
      editService(data){
        this.isNew = false;

        this.$store.dispatch('startLoader');
        this.updateServiceShopkeeper(data)
          .then(() => {
            this.getServices();
            this.makeToast(
              'Sucesso',
              'Serviço vinculado ao produto com sucesso!',
              'success'
            );
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao atualizar o serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      },
      addServiceProduct(data){
        this.$store.dispatch('startLoader');
        this.updateServiceShopkeeper(data)
          .then(() => {
            this.getServices();
            this.makeToast(
              'Sucesso',
              'Serviço vinculado ao produto com sucesso!',
              'success'
            );
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao atualizar o serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      },
      deleteService(id){
        this.$store.dispatch('startLoader');
        this.deleteServiceShopkeeper(id)
          .then(() => {
            this.makeToast(
              'Sucesso',
              'Serviço apagado com sucesso!',
              'success'
              );
            this.getServices();
          })
          .catch(() => {
            this.makeToast(
              'Erro',
              'Houve um erro ao deletar o serviço!',
              'danger'
            );
          })
          .finally(() => {
            this.$store.dispatch('endLoader');
          });
      },
      formatMoneyUn(value) {
        var money = parseFloat(value);
        return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
      },
      userTypeId() {
      return this.$route.meta.userType == UserTypes.BALCONISTA
        ? this.dadosUsuario.construp_user_id
        : this.dadosUsuario.id;
    },
    whatClerkPermission() {
      if (this.$route.meta.userType == UserTypes.BALCONISTA) {
        const permissionClerk = JSON.parse(
          localStorage.getItem('permissionClerk')
        );
        const permission = permissionClerk.find(
          (element) => element.name == NamePermission.CUSTOMIZACAO_EMPRESA
        );

        if (
          this.$route.meta.userType == UserTypes.BALCONISTA &&
          permission.type == TypePermission.BALCONISTA
        ) {
          return false;
        }
      }
      return true;
    },
  }
}
</script>